// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Label_wrapper__VBPMS","label":"Label_label__F87Zt","active":"Label_active__3DQEb","error":"Label_error__w_MEd"};